import React, { useEffect, useRef, useState } from 'react';
import './Contact.scss';
import ContactForm from '../ContactForm/ContactForm';
import Cover from '../Cover/Cover';
import MainButton from '../MainButton/MainButton';
import mapStyles from '../AmenitiesGMap/mapstyle.json';
import LinkedInIcon from '../LinkedInIcon/LinkedInIcon';
import InstagramIcon from '../InstagramIcon/InstagramIcon';
import FacebookIcon from '../FacbookIcon/FacebookIcon';
import TwitterIcon from '../TwitterIcon/TwitterIcon';
import { useSelector } from 'react-redux';
import MobileFooter from '../MobileFooter/MobileFooter';

const Contact = () => {
    const content = useSelector((state) => state.content.pages.contact);
    var mapContainer = useRef();
    var [gMap, setgMap] = useState(null);
    var mapData = useSelector((state) => state.content.pages.area);

    useEffect(() => {
        document.querySelector('#root').scrollTo(0, 0);
    }, []);

    function startMap(mainPin) {
        var map = {};
        map.markers = [];
        map.map = null;

        map.createMap = function(mainPin) {
            map.map = new window.google.maps.Map(mapContainer.current, {
                zoom: 15,
                center: {
                    lat: parseFloat(mainPin.latitude),
                    lng: parseFloat(mainPin.longitude)
                },
                styles: mapStyles
            });
        }

        map.addMarkers = function(mainPin) {
            this.removeMarkers();
            this.markers = [];

            this.markers.push(this.createMarker({
                lat: parseFloat(mainPin.latitude),
                lng: parseFloat(mainPin.longitude),
                name: "",
                icon: {
                    url: mainPin.icon,
                    //scaledSize: new window.google.maps.Size(182, 47)
                    scaledSize: new window.google.maps.Size(91, 23.5)
                },
            }));
        }

        map.removeMarkers = function() {
            for(var i = 0; i < this.markers.length; i++) {
                this.markers[i].setMap(null);
            }
        }

        map.createMarker = function(markerData) {
            var marker = new window.google.maps.Marker({
                position: {
                    lat: markerData.lat,
                    lng: markerData.lng,
                },
                map: this.map,
                icon: markerData.icon ? markerData.icon : ""
            });

            return marker;
        }

        map.createMap(mainPin);
        map.addMarkers(mainPin);
        return map;
    }

    //map effects
    useEffect(() => {
        if(typeof content !== 'undefined') {
            if(gMap == null) {
                setgMap(startMap(mapData.map[0].main_pin));
            }
        }
    });

    if (typeof content !== 'undefined') {
        return (
            <div className="contact">
                <Cover />
                <div className='g-map-wrapper'>
                    <div className='g-map-container' ref={mapContainer} />
                </div>
                <div className="contact-info-container">
                    <div className="contact-info">
                        <div className='heading-container'>
                            <h2>
                                {content.form_contact_info.heading}
                                <img
                                    className='h2-heading-decoration' 
                                    src={content.form_contact_info.heading_image}
                                />
                            </h2>
                        </div>
                        <div className='contact-info-grid'>
                            <a
                                className="contact-link"
                                href={content.form_contact_info.phone_number.tel_number}
                            >
                                <div className='icon-container'>
                                    {content.form_contact_info.phone_number.icon && (
                                        <img className='icon' src={content.form_contact_info.phone_number.icon} />
                                    )}
                                </div>
                                {content.form_contact_info.phone_number.label}
                            </a>
                            <span
                                className='contact-label'
                            >
                               <div className='icon-container'>
                                    {content.form_contact_info.address.link_icon && (
                                        <img className='icon' src={content.form_contact_info.address.link_icon} />
                                    )}
                               </div>
                               {content.form_contact_info.address.text_address}
                            </span>
                            <a
                                href={content.form_contact_info.email.mailto_address}
                                className="contact-link"
                            >
                                <div className='icon-container'>
                                    {content.form_contact_info.email.icon && (
                                        <img className='icon' src={content.form_contact_info.email.icon} />
                                    )}
                                </div>
                                {content.form_contact_info.email.label}
                            </a>
                            <a
                                className='contact-link contact-address'
                                href={content.form_contact_info.address.address_link}
                                target='_blank'
                            >
                               <div className='icon-container' />
                                {content.form_contact_info.address.link_label}
                            </a>
                            {content.form_contact_info.meeting_button.text && content.form_contact_info.meeting_button.link && (
                                <MainButton
                                    text={content.form_contact_info.meeting_button.text}
                                    link={content.form_contact_info.meeting_button.link}
                                    blank={content.form_contact_info.meeting_button.blank}
                                    external
                                />
                            )}
                            {content.form_contact_info.appointment_button.text && content.form_contact_info.appointment_button.link && (
                                <MainButton
                                    text={content.form_contact_info.appointment_button.text}
                                    link={content.form_contact_info.appointment_button.link}
                                    blank={content.form_contact_info.appointment_button.blank}
                                    external
                                />
                            )}
                        </div>
                        <div className='contact-footer-links'>
                            <div className="corporate-logos corporate-logos-desktop">
                                    <a href="https://graywoodgroup.com/" target="_blank">
                                        <img
                                            className='left-logo'
                                            src={
                                                content.form_contact_info.marlin_logo
                                                    .url
                                            }
                                            alt={
                                                content.form_contact_info.marlin_logo
                                                    .alt
                                            }
                                        />
                                    </a>
                                    <span className="separator"></span>
                                    <a
                                        href="https://www.falconcresthomes.com/"
                                        target="_blank"
                                    >
                                        <img
                                            className='right-logo'
                                            src={
                                                content.form_contact_info.greybrook_logo
                                                    .url
                                            }
                                            alt={
                                                content.form_contact_info.greybrook_logo
                                                    .alt
                                            }
                                        />
                                    </a>
                                </div>
                                {/*
                                <ul className="contact-social contact-social-desktop">
                                    <li>
                                        <a
                                            href="https://www.linkedin.com/"
                                            target="_blank"
                                        >
                                            <LinkedInIcon />
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="https://www.instagram.com/"
                                            target="_blank"
                                        >
                                            <InstagramIcon />
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="https://www.facebook.com/"
                                            target="_blank"
                                        >
                                            <FacebookIcon />
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="https://twitter.com/"
                                            target="_blank"
                                        >
                                            <TwitterIcon />
                                        </a>
                                    </li>
                                </ul>
                                */}
                            </div>
                            <div className='copyrights'>
                                <p className='disclaimer'
                                    dangerouslySetInnerHTML={{
                                        __html: `© ${new Date().getFullYear()} Graywood Sales Management Limited and Falconcrest Homes. <br/>All Rights Reserved. Specifications are subject to change at any time without notice E.&O.E. <br/>Illustrations are artist's concept. Interior Renderings feature a selection of upgrades. Speak to Sales rep for details.`
                                    }}
                                />
                                <div className='right'>
                                    <a className='pp' href='privacy-policy' target='_blank'>Privacy Policy</a>
                                    <span className='site-by'>
                                        Site by <a href='https://52pick-up.com' target='_blank'>52 Pick-up Inc.</a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        );
    } else {
        return <div></div>;
    }
};

export default Contact;
